import { useTranslation } from 'react-i18next';

const icons = [
  'ri-time-line',
  'ri-windy-line',
  'ri-drop-line',
];

export default function ProblemesTypiques() {
  const { t } = useTranslation('saintromuald');

  return (
    <section className="py-14 md:py-20 bg-soft-gray">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-manrope font-bold text-slate-primary text-center mb-10 md:mb-14">
          {t('problemes_h2')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 md:p-8"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-copper/10 mb-5">
                <i className={`${icons[i - 1]} text-copper text-xl`} />
              </div>
              <h3 className="text-base md:text-lg font-manrope font-bold text-slate-primary mb-3">
                {t(`probleme_${i}_title`)}
              </h3>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                {t(`probleme_${i}_desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}